import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import { FocusableParent, Focusable } from 'components/navigation';
import HorizontalList from 'components/HorizontalList';
import PageTitle from 'components/PageTitle';

export const SearchWrapper = styled.div`
  height: ${scaleSize(1080)}px;
  overflow: hidden;
  position: relative;
  padding-left: ${scaleSize(220)}px;
`;

export const KeyboardWrapper = styled.div`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(450)}px;
  background-color: ${({ theme }) => theme.imagePlaceholder};
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  padding-left: ${scaleSize(20)}px;

  & > div {
    margin-top: ${scaleSize(20)}px;
  }
`;

export const Placeholder = styled.div`
  height: ${scaleSize(600)}px;
  color: ${({ theme }) => theme.secondaryTextColor};
  background-color: ${({ theme }) => theme.backgroundColor};
  text-align: center;
  box-sizing: border-box;
  padding-top: ${scaleSize(180)}px;
  font-family: 'RobotoRegular', sans-serif;
  font-size: ${scaleSize(40)}px;
  font-weight: normal;
  line-height: 1.2;
  letter-spacing: normal;
  margin-left: ${scaleSize(-220)}px;

  & > span {
    width: ${scaleSize(550)}px;
    text-align: center;
    margin: 0 auto;
    display: block;
  }

  & > svg {
    width: ${scaleSize(192)}px;
    height: ${scaleSize(192)}px;

    & stroke {
      color: ${({ theme }) => theme.secondaryTextColor};
    }
  }
`;

export const Loading = styled.div`
  width: ${scaleSize(1700)}px;
  height: ${scaleSize(580)}px;
  line-height: ${scaleSize(580)}px;
  text-align: center;
`;

export const SearchPageTitle = styled(PageTitle)`
  top: ${scaleSize(70)}px;
  opacity: ${({ isHidden }) => (isHidden ? 0 : 1)};
`;

export const StyledSearchCategories = styled(FocusableParent)`
  position: relative;
  top: ${scaleSize(20)}px;
  left: ${scaleSize(220)}px;
`;

export const StyledSearchCategory = styled(Focusable)`
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
  height: ${scaleSize(104)}px;
  padding: ${scaleSize(20)}px ${scaleSize(40)}px;
  margin-right: ${scaleSize(20)}px;
  border-radius: ${scaleSize(12)}px;
  color: ${({ theme }) => theme.mainTextColor};
  font-family: RobotoCondensedBold, sans-serif;
  font-weight: 700;
  font-size: ${scaleSize(48)}px;
  line-height: ${scaleSize(64)}px;
  text-align: center;
  background-color: ${({ theme }) => theme.imagePlaceholder};

  &:focus {
    color: ${({ theme }) => theme.defaultColor};
    background: ${({ theme }) => theme.activeColor};
  }
`;

export const StyledSearchResultsList = styled(HorizontalList)`
  position: relative;
  top: ${scaleSize(50)}px;
  left: ${scaleSize(220)}px;
`;
